import React from 'react';

const SuccessIcon = (props) => {
  return (
    <svg
      // dataname='Layer 2'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 40 40'
      className={props.className || null}
      style={{
        height: props.height ? `${props.height}px` : '',
        width: props.width ? `${props.width}px` : ''
      }}
    >
      <g
        // dataname='Layer 1'
      >
        <circle
          cx='20'
          cy='20'
          r='20'
          style={{ fill: '#00b080' }}
        />
        <path
          style={{
            fillRule: 'evenodd',
            stroke: '#fff',
            strokeMiterlimit: '10',
            strokeWidth: '2.99px',
            fill: '#00b080'
          }}
          d='m7.94 20.98 7.63 7.62 16.49-17.2'
        />
      </g>
    </svg>
  );
};

export default SuccessIcon;
